import React from 'react';
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Tooltip } from 'recharts';

const data = [
  { subject: 'Consistency', A: 85, fullMark: 100 },
  { subject: 'Code Quality', A: 92, fullMark: 100 },
  { subject: 'Collaboration', A: 78, fullMark: 100 },
  { subject: 'Documentation', A: 95, fullMark: 100 },
  { subject: 'Feedback', A: 88, fullMark: 100 },
];

const ReputationViz = () => {
  return (
    <section id="reputation" className="py-24 bg-white border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Reputation & Progression</h2>
            <p className="text-lg text-slate-600 mb-8">
              Contribution is recorded. Performance is evaluated. Progression is earned.
              Reputation within the ecosystem is built through sustained performance, not just attendance.
            </p>
            
            <ul className="space-y-4 mb-8">
              {[
                "Contribution consistency",
                "Code quality analysis",
                "Collaboration discipline",
                "Documentation standards",
                "Mentor feedback outcomes"
              ].map((item, i) => (
                <li key={i} className="flex items-center text-slate-700">
                  <span className="w-1.5 h-1.5 bg-slate-900 rounded-full mr-3"></span>
                  {item}
                </li>
              ))}
            </ul>

            <div className="p-4 bg-slate-50 border border-slate-200 text-sm text-slate-500 rounded-sm">
              * The visualization represents a standard intern profile evaluation matrix.
            </div>
          </div>

          <div className="bg-slate-50 border border-slate-200 rounded-sm p-6 flex flex-col items-center">
            <h3 className="text-sm font-bold uppercase tracking-widest text-slate-500 mb-4">Metric Visualization</h3>
            <div className="w-full h-[300px] sm:h-[400px]">
              <ResponsiveContainer width="100%" height="100%">
                <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
                  <PolarGrid stroke="#e2e8f0" />
                  <PolarAngleAxis dataKey="subject" tick={{ fill: '#475569', fontSize: 12, fontWeight: 500 }} />
                  <PolarRadiusAxis angle={30} domain={[0, 100]} tick={false} axisLine={false} />
                  <Radar
                    name="Performance"
                    dataKey="A"
                    stroke="#0f172a"
                    strokeWidth={2}
                    fill="#0f172a"
                    fillOpacity={0.1}
                  />
                  <Tooltip 
                    contentStyle={{ backgroundColor: '#fff', borderColor: '#e2e8f0', fontSize: '12px' }}
                    itemStyle={{ color: '#0f172a' }}
                  />
                </RadarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReputationViz;
